// Import app styles
import "./styles/main.scss";

// Add assets to /dist
import "./assets/favicon.ico";

// Add polyfills
import "core-js/es/promise";
import "core-js/es/array";
